import calculateIndexMap from "./calculateIndexMap";
import calculateIndexMap2 from "./calculateIndexMap2";

/*
  Split items into n columns (vertical / column-first fill).
  Always returns exactly `columns` arrays so the layout cannot
  drop a column or loop when there are fewer names than columns.
*/
const splitArray = (items, options) => {
  const columns = Math.max(1, Number(options.columns) || 1);
  const list = Array.isArray(items) ? items : [];
  const n = Math.floor(list.length / columns);
  const extra = list.length - n * columns;

  let middle = columns % 2 === 0 ? columns / 2 + 1 : Math.ceil(columns / 2);
  if (columns === 2) {
    middle = 1;
  }
  const indexMap = options.balance_columns
    ? calculateIndexMap(extra, middle)
    : calculateIndexMap2(extra, middle);

  const ans = [];
  let offset = 0;
  for (let i = 1; i <= columns; i++) {
    const take = n + (indexMap[i] === true ? 1 : 0);
    ans.push(list.slice(offset, offset + take));
    offset += take;
  }
  return { ans, indexMap };
};
export default splitArray;
